import React from "react";
import { DefaultSeo } from "next-seo";

export const createTitle = (title: string): string => `F*CE | ${title}`;

export const DefaultSEO: React.FC = () => {
  const title = createTitle("Store");
  const description = "Belgian Brewed Skate Company";
  return (
    <DefaultSeo
      title={title}
      defaultTitle={title}
      description={description}
      openGraph={{
        type: "website",
        locale: "en_IE",
        url: "https://www.fcegng.com",
        site_name: "F*CE",
        description,
      }}
    />
  );
};
